export const Hero = () => (
  <section data-testid="hero-section" className="px-6 md:px-12 pt-16 pb-20 max-w-6xl mx-auto">
    <div className="flex items-center gap-2 mb-6 font-monolbl text-xs uppercase tracking-[0.2em] text-forest">
      <span className="w-2 h-2 rounded-full bg-forest"></span>
      <span>CPD-Accredited 3-Day Qualification • London</span>
    </div>

    <h1
      data-testid="hero-title"
      className="font-display text-4xl sm:text-6xl md:text-7xl lg:text-[5.5rem] tracking-tight leading-[0.98] text-ink mb-8"
    >
      <span className="block overflow-hidden">
        <span className="block animate-line-up">Master the signature</span>
      </span>
      <span className="block overflow-hidden">
        <span className="block animate-line-up italic text-forest" style={{ animationDelay: "0.12s" }}>
          LymphoMetabolic
        </span>
      </span>
      <span className="block overflow-hidden">
        <span className="block animate-line-up" style={{ animationDelay: "0.24s" }}>
          manual protocol.
        </span>
      </span>
    </h1>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end animate-fade-up">
      <div className="md:col-span-7">
        <p className="text-lg md:text-xl text-sage leading-relaxed max-w-xl">
          Elisabete Lopes' proprietary fusion of deep visceral manual therapy and targeted
          lymphatic drainage, taught in London over three rigorous days.
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <a
            data-testid="hero-enquire-button"
            href="#enquire"
            className="px-7 py-3.5 rounded-full bg-forest text-linen text-sm uppercase tracking-wider font-semibold hover:bg-ink transition-colors shadow-md"
          >
            Enquire for Upcoming Dates
          </a>
          <a
            data-testid="hero-fees-button"
            href="#pricing"
            className="px-6 py-3.5 rounded-full border border-forest/30 text-forest text-sm uppercase tracking-wider font-medium hover:border-forest transition-colors"
          >
            View Therapist &amp; Salon Fees
          </a>
        </div>
      </div>

      <div className="md:col-span-5">
        <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-lg border border-cream">
          <img
            data-testid="hero-image"
            src="/images/elisabete-lopes.jpg"
            alt="Elisabete Lopes, founder of the LymphoMetabolic method"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute bottom-4 left-4 right-4 bg-linen/90 backdrop-blur px-4 py-2.5 rounded-xl border border-cream flex items-center justify-between">
            <span className="font-monolbl text-[11px] uppercase tracking-wider text-forest font-semibold">
              Taught by Founder
            </span>
            <span className="text-xs text-moss">London Venues SE24 &amp; SW9</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
